import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Subject, takeUntil } from 'rxjs';

import { TwcPopupService } from '@topcon/twc-angular';

import { JobSiteService, ToastService } from '@mirage-projects/cw-commons';
import { Project, RelatedJobSitesInfo } from '@mirage-projects/cw-models';

/**
 * It shows a popup with a list of the related sites of a specific project
 */
@Component({
    selector: 'cw-related-sites-dialog',
    templateUrl: './related-sites-dialog.component.html',
    styleUrls: ['./related-sites-dialog.component.scss'],
    standalone: false,
})
export class RelatedSitesDialogComponent implements OnInit, OnDestroy {
    /** Receives the project data */
    @Input() object!: Project;

    private onDestroy$ = new Subject<void>();

    isLoading = false;
    siteList: RelatedJobSitesInfo[] = [];

    constructor(
        private router: Router,
        private twcPopupService: TwcPopupService,
        private jobSiteService: JobSiteService,
        private toastService: ToastService
    ) {}

    ngOnInit(): void {
        if (!this.object.name) {
            throw new Error('Object must have a name');
        }
        this.updateSiteList();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    /**
     * Open the selected site on the poup
     * @param siteId id number of the selected site
     */
    openSelectedSite(siteId: number): void {
        this.router.navigate([`/site-viewer/${siteId}`]);
    }

    /**
     * Dettach the project from the selected site
     * @param siteId id number of the selected site
     * @param projectId id number of the selected project
     */
    dettachProjectFromSelectedSite(siteId: number, projectId: number | undefined): void {
        if (!projectId) {
            return;
        }
        this.isLoading = true;
        this.jobSiteService
            .dettachProjects(siteId, [projectId])
            .pipe(takeUntil(this.onDestroy$))
            .subscribe({
                next: () => {
                    this.object.sites = this.object.sites?.filter((site: RelatedJobSitesInfo) => site.id !== siteId) || [];
                    this.updateSiteList();
                    this.isLoading = false;
                },
                error: () => {
                    this.isLoading = false;
                    this.toastService.error('PROJECTS.ERROR_DETTACHING');
                },
            });
    }

    private updateSiteList(): void {
        if (this.object.sites?.length === 0) {
            this.close();
        }
        this.siteList = this.object.sites || [];
    }

    private close(): void {
        this.twcPopupService.hideAll();
    }
}
